import style from "./style.scss";
import Emoji from "../emoji";
import { mergeClasses } from "../helpers";

const Warning = ({
  prefix,
  icon = true,
  blue = false,
  green = false, //TODO: Use TypeScript enum
  class: className = null,
  children,
}) => (
  <div
    class={mergeClasses([
      style.warning,
      blue ? style.blue : null,
      green ? style.green : null,
      className,
    ])}
  >
    {icon && <Emoji>⚠</Emoji>}{" "}
    {prefix ? <strong class={style.prefix}>{prefix}:</strong> : null} {children}
  </div>
);
export default Warning;
